<template>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card light>
        <v-card-title class="headline grey--text">
            <h5>Equipo: <strong>{{ team }}</strong></h5>
        </v-card-title>
        <v-card-text class="pt-0">
            <v-container fluid grid-list-xs>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-text-field
                            light
                            label="Pago"
                            class="green--text"
                            v-model="data.payment"
                            type="number"
                            min="0"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 class="grey--text">
                        <p class="subheading mb-0">Total a </p>
                        <p class="subheading">USD $100.00</p>
                    </v-flex>
                    <v-flex xs12 class="grey--text">
                        <p class="subheading mb-0">Pagado</p>
                        <p class="subheading">USD $1.00</p>
                    </v-flex>
                    <v-flex xs12 class="grey--text">
                        <p class="subheading mb-0">Saldo al Corte</p>
                        <p class="subheading">USD $99.00</p>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="confirm(false)">Cancelar</v-btn>
          <v-btn color="green darken-1" flat @click.native="confirm(true)">Agregar Pago</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: 'PaymentModal',
        props: {
            dialog: { required: true, default: false },
            team: { required: true, default: '' },
        },
        data() {
            return {
               data: {
                   payment: 0
               } 
            }
        },
        methods: {
            confirm(btnPressed) {
                let response = {
                    'response': btnPressed,
                    'data': this.data
                }
                
                this.$emit('response', btnPressed ? response : btnPressed)
            }
        }
    }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/tournaments/account_status/PaymentModal.vue